import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, title, testId }) => (
  <div className="flex items-center gap-4" data-testid={testId}>
    <span className="font-serif text-lg italic text-gold">{number}</span>
    <span className="h-px w-12 bg-champagne/40" />
    <span className="text-xs uppercase tracking-[0.3em] text-champagne font-medium">
      {title}
    </span>
  </div>
);

export const Hairline = ({ className = "" }) => (
  <div className={`hairline-gold ${className}`} />
);
